export default __webpack_public_path__ + "static/media/checkmark.408ac927.svg";